import { useReducer, useCallback } from 'react';
import * as URL from '../../../../constant/kollusUrl';

function reducer(state, action) {
  switch (action.type) {
    case 'SET': {
      const patch = typeof action.data === 'function' ? action.data(state) : action.data;
      return { ...state, ...patch };
    }

    case 'LIVE_PLAY':
      return {
        ...state,
        nowPlaying: 'LIVE',
        livePlayed: true,
        podcastPlayed: false,
        vodPlayed: false,
        footerPlayed: true,
      };

    case 'LIVE_STOP':
      return {
        ...state,
        livePlayed: false,
        nowPlaying: 'LIVE',
        footerPlayed: false,
        isLoading: false,
      };

    case 'CLEAR_LIVE':
      return {
        ...state,
        livePlayed: false,
        footerPlayed: false,
        liveController: null,
        nowPlaying: null,
      };

    case 'WATCH_PLAY':
      try {
        if (state.livePlayed) state.liveController?.pause?.();
        if (state.podcastPlayed) state.aodController?.pause?.();
      } catch (e) {
        console.error(e);
      }
      return {
        ...state,
        nowPlaying: 'WATCH',
        livePlayed: false,
        podcastPlayed: false,
        vodPlayed: false,
        footerPlayed: false,
        watchPlayed: true,
        watchController: action.data || state.watchController,
      };

    case 'WATCH_STOP':
      return {
        ...state,
        watchPlayed: false,
      };

    case 'PODCAST_PLAY':
      try {
        if (state.livePlayed) state.liveController?.pause?.();
      } catch (e) {
        console.error(e);
      }
      return {
        ...state,
        nowPlaying: 'PODCAST',
        livePlayed: false,
        podcastPlayed: true,
        vodPlayed: false,
        footerPlayed: true,
        aodController: action.data || state.aodController,
        isLoading: false,
      };

    case 'PODCAST_STOP':
      return {
        ...state,
        livePlayed: false,
        podcastPlayed: false,
        footerPlayed: false,
        aodController: action.data || state.aodController,
        isLoading: false,
        loadingTarget: null,
      };

    case 'PODCAST_PROGRESS':
      return {
        ...state,
        playPercent: action.data.playPercent,
        playPosition: action.data.playPosition,
        playDuration: action.data.playDuration,
      };

    case 'PODCAST_STREAM_SET': {
      if (state.podcastStream && state.podcastStream.length > 0) {
        return state;
      }
      return { ...state, podcastStream: action.data };
    }

    case 'CLEAR_PODCAST':
      return {
        ...state,
        aod: null,
        podcastStream: null,
        podcastPlayed: false,
        footerPlayed: false,
        aodController: null,
        playPercent: 0,
        playPosition: 0,
        playDuration: 0,
      };

    case 'VOD_PLAY':
      try {
        if (state.livePlayed) state.liveController?.pause?.();
        if (state.podcastPlayed) state.aodController?.pause?.();
      } catch (e) {
        console.error(e);
      }
      return {
        ...state,
        nowPlaying: 'VOD',
        livePlayed: false,
        podcastPlayed: false,
        vodPlayed: true,
        footerPlayed: false,
        vodController: action.data || null,
      };

    case 'VOD_STOP':
      return { ...state, vodPlayed: false };

    case 'AOD_SET': {
      const [aod, stream, liveData] = action.data;
      const nextStream = state.podcastStream?.length > 0 ? state.podcastStream : stream;
      const targetAod = aod || state.aod;

      return {
        ...state,
        aod: targetAod,
        podcastStream: nextStream,
        liveData: liveData ? { ...state.liveData, ...liveData } : state.liveData,
      };
    }

    case 'AOD_SET_AND_PLAY': {
      const [aod, stream, liveData] = action.data;
      try {
        if (state.livePlayed) state.liveController?.pause?.();
        if (state.vodPlayed) state.vodController?.pause?.();
      } catch (e) {
        console.error(e);
      }

      const nextStream = stream && stream !== state.podcastStream ? stream : state.podcastStream;
      const targetAod = aod || state.aod;

      return {
        ...state,
        aod: targetAod,
        podcastStream: nextStream,
        liveData: liveData ? { ...state.liveData, ...liveData } : state.liveData,
        nowPlaying: 'PODCAST',
        livePlayed: false,
        podcastPlayed: true,
        vodPlayed: false,
        footerPlayed: true,
      };
    }

    case 'LOADING_START':
      return { ...state, isLoading: true, loadingTarget: action.data ?? null };

    case 'LOADING_STOP':
      return { ...state, isLoading: false, loadingTarget: null };

    default:
      return state;
  }
}

const useMediaPlayer = () => {
  const [state, dispatch] = useReducer(reducer, {
    aod: null,
    podcastStream: null,
    liveData: { liveURL: URL.LIVE_RADIO },
    nowPlaying: 'LIVE',
    aodController: null,
    liveController: null,
    livePlayed: false,
    footerPlayed: false,
    podcastPlayed: false,
    vodController: null,
    vodPlayed: false,
    isLoading: false,
    loadingTarget: null,
    playPercent: 0,
    playPosition: 0,
    playDuration: 0,
    watchPlayed: false,
    watchController: null,
  });

  const mediaType = useCallback((media, data) => {
    dispatch({ type: media, data });
  }, []);

  return [state, mediaType];
};

export default useMediaPlayer;
